export const ACCOUNT_ID_FILTER = 'account.id'

export const SEGMENT_FIELDS = [
  { value: 'deposit.count', text: 'Deposit count' },
  { value: 'deposit.amount', text: 'Deposit amount' },
  { value: ACCOUNT_ID_FILTER, text: 'Account ID' },
  { value: 'account.type', text: 'Account type' },
  { value: 'account.country', text: 'Account country' },
  { value: 'account.language', text: 'Account language' },
  { value: 'account.currency', text: 'Account currency' },
  { value: 'account.affiliate', text: 'Affiliate' },
  { value: 'account.btag', text: 'B-Tag' },
  { value: 'account.level', text: 'VIP Level' },
  { value: 'account.unfunded', text: 'Unfunded days' },
  { value: 'account.autobonus', text: 'Account autobonus' },
  { value: 'account.avatar', text: 'Account avatar' },
  { value: 'account.balance', text: 'Account balance' },
  { value: 'account.birthday', text: 'Account birthday' },
  { value: 'deposit.last_day', text: 'Deposit last day' },
  { value: 'kyc.verified', text: 'KYC verified' },
  { value: 'kyc.primary_verification', text: 'KYC primary verification' },
  { value: 'account.data.verified.phone', text: 'Account phone verified' },
  { value: 'account.data.verified.email', text: 'Account email verified' },
]

export const SEGMENT_IN = 'in'
export const SEGMENT_NOT_IN = 'notin'
export const SEGMENT_EQUATION = [
  '=',
  '>',
  '=>',
  '>=',
  '<',
  '<=',
  '=<',
  '!=',
  SEGMENT_IN,
  SEGMENT_NOT_IN,
]

export const getBonusDefaults = () => ({
  max_release: [
    { currency: 'EUR', amount: 0 },
  ],
  lifetime: {
    amount: 0,
    period: 'days',
  },
  sticky: false,
  wager: 0,
  status: 'active',
  name: '',
  type: 'casino',
  rollover_type: 'bonus',
})

export const getEmptyJackpot = (defaultEntities = []) => ({
  name: '',
  status: 'upcoming',
  entities: defaultEntities,
  start: '',
  end: '',
  rules: {
    bonus: getBonusDefaults(),
    draw: {
      amount: 0,
      period: 'days',
    },
    prizepool: [
      { currency: 'EUR', amount: 0 },
    ],
    contribution: {
      min_bet: [
        { currency: 'EUR', amount: 0 },
      ],
    },
    game_types: {
      include: [],
      exclude: [],
    },
    games: {
      include: [],
      exclude: [],
    },
    brands: {
      include: [],
      exclude: [],
    },
    filter: [
      { field: 'account.id', equation: 'in', value: [] },
      { field: '', equation: '=', value: '' },
    ],
    type: JACKPOT_TYPE_OPTIONS[0].value,
    show_for_guests: false,
  },
})

export const STATUS_ACTIVE = 'active'
export const STATUS_FINISHED = 'finished'

export const STATUS_OPTIONS = [
  { text: 'Upcoming', value: 'upcoming' },
  { text: 'Active', value: STATUS_ACTIVE },
  { text: 'Finished', value: STATUS_FINISHED },
  { text: 'Disabled', value: 'disabled' },
]

export const COLOR_BY_STATUS = {
  upcoming: 'blue',
  active: 'primary',
  finished: 'black',
  disabled: 'error',
}

export const JACKPOT_TYPE_OPTIONS = [
  { text: 'Mini', value: 'mini' },
  { text: 'Standard', value: 'standard' },
  { text: 'Mega', value: 'mega' },
  { text: 'Super', value: 'super' },
  { text: 'Grand', value: 'grand' },
]

